import { ADD_NOTIFICATION, CLEAR_NOTIFICATIONS } from '../_actions/types';

const initialState = {
  notifications: [],
};

export default function notificationReducer(state = initialState, action) {
  switch (action.type) {
    case ADD_NOTIFICATION:
      return {
        ...state,
        notifications: [action.payload, ...state.notifications],
      };
    case CLEAR_NOTIFICATIONS:
      return {
        ...state,
        notifications: state.notifications.map(notification => {
          if (notification.resumeId === action.payload) {
            return { ...notification, isRead: true };
          }
          return notification;
        })
      };
    default:
      return state;
  }
}
